export const LINK_NO_HREF = "#";
export const EMPTY_VALUE = "–";
export const LONG_WHITE_SPACE = "\u00a0";
export const GEOSPATIAL_LAT_LON_DELIMITER = ", ";
export const APP_DRAWER_ELEMENT_ID = "app-page-drawer";
export const APP_HEADER_ELEMENT_ID = "app-page-header";
export const WITH_APP_PAGE_BODY_SIZES_CLASS_NAME = "with-app-page-body-sizes";
export const APP_SIZES = {
    LOGO_HEIGHT: 52,
    HEADER_HEIGHT: 0,
    SIDEBAR_MAIN_WIDTH: 300,
    SIDEBAR_COLLAPSED_WIDTH: 48,
    SIDEBAR_TAB_HEIGHT: 36,
    SIDEBAR_TABS_LOGO_SIZE: 26
};
export const MODAL_ELEMENT_ID_PREFIX = "modal-popover";
export const MODAL_CONTENT_ID_PREFIX = "modal-popover-content";
export const PROGRESS_OVERLAY_ID_PREFIX = "progress-overlay";
export const TAB_PANEL_CLASS_NAME = "react-tab-panel";
export const TAB_CLASS_NAME = "react-tab";
export const TABS_CLASS_NAME = "react-tab";
export const DRAGGABLE_TYPES = {
    DOCUMENT_OBJECT: "object",
    SUMMARY_REPORT_OBJECT: "summaryReportObject"
};
export const GRAPH_DEFAULT_NODE_CLASS_NAME = "custom-node";
export const GRAPH_COLORED_NODE_CLASS_NAME = "custom-node-colored";
export const GRAPH_GROUP_NODE_CLASS_NAME = "custom-node-group";
export const GRAPH_GROUP_NODE_LABEL_CLASS_NAME = "group-node-label";
export const GRAPH_GROUP_NODE_LABEL_TABLE_CLASS_NAME = "group-node-label-table";
export const REGULAR_NODE_CAPTION_CLASS_NAME = "regular-node-caption";
export const REGULAR_NODE_TYPE_CLASS_NAME = "regular-node-type";
